import { FC, useCallback } from "react";
import { Box, Button } from "@mui/material";
import { useFlag } from "@unleash/proxy-client-react";
import { useNavigate } from "react-router-dom";

export const TestAiSavingOpportunitiesButton: FC = () => {
  const enableTestAiSavingOpportunities = useFlag(
    "EnableTestAiSavingOpportunities",
  );

  const navigate = useNavigate();

  const clickHandler = useCallback(() => {
    navigate("/test-api-saving-opportunities");
  }, [navigate]);

  if (!enableTestAiSavingOpportunities) {
    return null;
  }

  return (
    <Box p={1}>
      <Button onClick={clickHandler} size="small" variant="outlined">
        Test AI Savings Opportunities
      </Button>
    </Box>
  );
};
